module.exports = __webpack_public_path__ + "static/media/iphone-gold.0ba26eee.png";